import { GetRequestOptions } from "./grunt";
import { loggedOper as lp } from "./grunt";
const PthGovScan=process.env.REACT_APP_GRUNT_API+"/scan/gov";
const PthUpdatePutnicaSerbr=process.env.REACT_APP_GRUNT_API+"/scan/gov/updateputnicaserbr/";
const PthGovScanByMigracijaId=process.env.REACT_APP_GRUNT_API+"/scan/gov/govscans/migracija/";
const PthGovScanResult=process.env.REACT_APP_GRUNT_API+"/scan/gov/govscanresult";
const StatusOk={status:200};

const getGovScans=async(_readyformigracija=false, _neprovedenemigracije=true)=>{
    try {
        
        const _qrystr=`?readyformigracija=${_readyformigracija}&neprovedenemigracije=${_neprovedenemigracije}`;
        const r = await fetch(PthGovScan+_qrystr, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka skeniranja. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getGovScansByMigracijaId=async(_migracijaid)=>{
    try {
        
        
        const r = await fetch(PthGovScanByMigracijaId+_migracijaid, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka skeniranja. " + ex.message, status: ex.status, name: ex.name};
    }
}


const getGovScanResult=async({_govscanid=0,_govscansid=[]})=>{
    try {
        
        const _reqopt=GetRequestOptions("GET");
        let _pth=PthGovScanResult;
        if (_govscansid.length===0) {
            _pth=_pth+"/"+_govscanid;
        } else {
            
            _pth=_pth+"?govscanid="+_govscansid.toString();
        }
        
        //const r = await fetch(PthGovScanResult+"/"+_govscanid, GetRequestOptions("GET"));    
        const r = await fetch(_pth, _reqopt);    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka skeniranja. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getGovScanResultPutniceSerbr=async(_govscanid=0)=>{
    try {
        
        const _reqopt=GetRequestOptions("GET");
        let _pth=PthGovScanResult+'/putniceserbr/'+_govscanid.toString();
        const r = await fetch(_pth, _reqopt);    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka skeniranja. " + ex.message, status: ex.status, name: ex.name};
    }
}

const delGovScanResult=async({_govscanid})=>{
    try {
        
        
        const r = await fetch(PthGovScanResult+"/"+_govscanid, GetRequestOptions("DELETE"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka skeniranja. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getGovScanResultItemPdf=async(_govscanresultid)=>{
    try {
        
        
        const r = await fetch(PthGovScanResult+"/pdf/"+_govscanresultid, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka skeniranja. " + ex.message, status: ex.status, name: ex.name};
    }
}

const delGovScanResultItem=async(_govscanresultid)=>{
    try {
        
        
        const r = await fetch(PthGovScanResult+"/item/"+_govscanresultid, GetRequestOptions("DELETE"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod brisanja podataka skeniranja. " + ex.message, status: ex.status, name: ex.name};
    }
}


const updGovScanResultItem=async({_govscanresultid=0,_zivbradjusted="",_mzivbradjusted="",_spoladjusted="",_pasminasifraadjusted="",_datrodadjusted,_putnica_serbr_adjusted=""})=>{
    try {
        
        /*
        let _reqopt=GetRequestOptions("POST");
        _reqopt.body=JSON.stringify({dokumenttipid:dokumenttipid,migracijatipsifra:migracijatipsifra,knjigaid:knjigaid,datum:datum,
            posjednikid:posjednikid,uktezina:uktezina,
            ijr:ijr,dokumentbroj:dokumentbroj,goveda:goveda});
        */
       let _reqopt=GetRequestOptions("PUT");
       _reqopt.body=JSON.stringify({zivbr_adjusted:_zivbradjusted,mzivbr_adjusted:_mzivbradjusted,spol_adjusted:_spoladjusted,pasminasifra_adjusted:_pasminasifraadjusted,datrod_adjusted:_datrodadjusted,putnica_serbr_adjusted:_putnica_serbr_adjusted});
        const r = await fetch(PthGovScanResult+"/item/"+_govscanresultid, _reqopt);    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod brisanja podataka skeniranja. " + ex.message, status: ex.status, name: ex.name};
    }
}
//gov/updateputnicaserbr/:govscanid
const updPutnicaSerBr=async({_govscanid=0})=>{
    try {
       let _reqopt=GetRequestOptions("PUT");
        const r = await fetch(PthUpdatePutnicaSerbr+_govscanid.toString(), _reqopt);    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod ažuriranja brojeva putnih listova.. " + ex.message, status: ex.status, name: ex.name};
    }
}

const addGovScans=async({file,name,type,size})=>{
    try {
        let reqopt={};
        reqopt.method="POST";
        reqopt.credentials='same-origin';
        reqopt.body=file;
        reqopt.headers= {
            'content-type': type,
            'content-length': `${size}`, // 👈 Headers need to be a string
            'Authorization':lp.token,
            'filename':name,
          }
        const r = await fetch(PthGovScan, reqopt);    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod slanja dokumenata na skeniranje. " + ex.message, status: ex.status, name: ex.name};
    }
}


export {getGovScans,addGovScans,getGovScanResult,getGovScanResultItemPdf,delGovScanResultItem,
    updGovScanResultItem,delGovScanResult,getGovScansByMigracijaId,getGovScanResultPutniceSerbr,updPutnicaSerBr}